import DropDown from '@/trio-ui/Dropdown';
import InputText from '@/trio-ui/InputText';
import { countriesOptions } from '@/utils/dropdownOptions';
import { Grid, InputWrapper } from './PersonalInfoAddressForm.styles';

type Props = {
  addressLine1: string;
  addressLine2: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
  onChange: (name: string, value: any) => void;
};

const PersonalInfoAddressForm = ({
  addressLine1,
  addressLine2,
  zipCode,
  city,
  state,
  country,
  onChange,
}: Props): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    onChange(e.target.name, e.target.value);
  };

  return (
    <Grid>
      <InputWrapper>
        <InputText
          label="Address Line 1"
          name="addressLine1"
          value={addressLine1}
          onChange={handleChange}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText label="City" name="city" value={city} onChange={handleChange} />
      </InputWrapper>
      <InputWrapper>
        <InputText
          label="Address Line 2"
          name="addressLine2"
          value={addressLine2}
          onChange={handleChange}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText label="State/Province" name="state" value={state} onChange={handleChange} />
      </InputWrapper>
      <InputWrapper>
        <InputText label="Zip Code" name="zipCode" value={zipCode} onChange={handleChange} />
      </InputWrapper>
      <InputWrapper>
        <DropDown
          label="Country"
          options={countriesOptions}
          name="country"
          defaultValue={country}
          onChangeDropDown={handleChange}
        />
      </InputWrapper>
    </Grid>
  );
};

export default PersonalInfoAddressForm;
